<template>
  <div class="member-classes">
    <el-tabs class="el-tabs-common" v-model="params.is_processing">
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :name="item.name"
        :label="item.label"
      ></el-tab-pane>
    </el-tabs>
    <List
      class="list"
      ref="list"
      url="/api/app/myClassList"
      :search="params"
      :limit="15"
      :alwaysShowPager="false"
      @page-load="onListLoad"
    >
      <template v-slot="{ list }">
        <div class="classes-list">
          <div class="classes-item" v-for="item in list" :key="item.id">
            <img class="classes-cover" :src="item.cover_image" />
            <img
              v-if="item.is_processing == 1"
              class="classes-processing"
              src="@/assets/images/classes/processing-1@2x.png"
            />
            <img
              v-else-if="item.is_processing == 2"
              class="classes-processing"
              src="@/assets/images/classes/processing-2@2x.png"
            />
            <div class="classes-main">
              <div class="classes-title bold6">{{ item.class_name }}</div>
              <div class="classes-info">
                <span>
                  <span>共</span>
                  <span class="classes-course_num bold6">
                    <span>{{ item.courseNum }}</span>
                  </span>
                  <span>门课程</span>
                </span>
                <span v-if="item.classify_name">{{ item.classify_name }}</span>
                <span v-if="item.grade_name">{{ item.grade_name }}</span>
              </div>
              <div class="classes-join">
                <span>
                  <span class="classes-label">入班时间：</span>
                  <span class="classes-value">
                    <span>{{ item.join_time | tsFormatLong }}</span>
                  </span>
                </span>
                <span>
                  <span class="classes-label">有效期至：</span>
                  <span class="classes-value" v-if="item.valid_type == 1">
                    <span>长期有效</span>
                  </span>
                  <template v-else>
                    <span class="classes-value">
                      <span>{{ item.valid_time | tsFormatLong }}</span>
                    </span>
                  </template>
                </span>
              </div>
              <div class="classes-rate">
                <span class="classes-label">学习进度：</span>
                <span class="classes-rate_value">{{ item.rate }}%</span>
                <div class="classes-progress">
                  <div class="classes-progress_value" :style="{ width: item.rate + '%' }"></div>
                </div>
              </div>
            </div>
            <router-link
              class="classes-study"
              :class="item.valid_type != 1 && item.valid_time < nowDate ? 'disabled' : ''"
              :to="{
                name: 'MemberClassesDetail',
                params: { id: item.class_id },
              }"
            >
              {{
                item.is_processing == 1
                  ? item.valid_type != 1 && item.valid_time < nowDate
                    ? '已过期'
                    : '立即学习'
                  : '查看班级'
              }}
            </router-link>
          </div>
        </div>
        <EmptyNew v-if="list.length == 0" class="classes-detail-empty" title="暂无内容" />
      </template>
    </List>
  </div>
</template>
<script>
import List from '@/components/List.vue';
import EmptyNew from '@/components/EmptyNew.vue';
import { triggerLoaded } from '@/components/LoadContainer.vue';

export default {
  name: 'MemberClasses',
  components: { List, EmptyNew },
  data() {
    return {
      tabs: [
        { name: '3', label: '全部' },
        { name: '1', label: '上课中' },
        { name: '2', label: '已结业' },
      ],
      params: {
        is_processing: '3',
      },
      nowDate: Date.now() / 1000,
    };
  },
  watch: {
    'params.is_processing': {
      handler() {
        this.$refs.list.searchRefresh();
      },
    },
  },
  methods: {
    onListLoad() {
      triggerLoaded(this);
    },
  },
};
</script>
<style lang="scss" scoped>
.member-classes {
  padding: 4px 24px 24px 24px;
  background: #fff;
  ::v-deep {
    .pager {
      padding: 24px 0 !important;
    }
  }
}
.classes-item {
  display: flex;
  position: relative;
  padding: 24px 0;
  border-bottom: 1px solid #e6e6e6;

  &:first-child {
    padding-top: 12px;
  }
}
.classes-processing {
  width: 56px;
  position: absolute;
}
.classes-cover {
  width: 210px;
  height: 140px;
  margin-right: 24px;
}
.classes-main {
  flex: 1;
}
.classes-title {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Semibold;
  line-height: 22px;
  margin-bottom: 6px;
}
.classes-info {
  display: flex;
  color: #999999;
  margin-bottom: 36px;
}
.classes-info > span,
.classes-join > span {
  padding-right: 10px;
  margin-right: 10px;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    width: 1px;
    height: 16px;
    top: 2px;
    right: 0;
    background: #cccccc;
  }
  &:last-child::after {
    display: none;
  }
}
.classes-course_num {
  font-family: PingFangSC, PingFangSC-Semibold;
  color: #666;
  margin: 0 4px;
}
.classes-label {
  color: #999;
}
.classes-value {
  color: #666;
}
.classes-join {
  margin-bottom: 14px;
}
.classes-rate {
  display: flex;
  align-items: center;
}
.classes-progress {
  width: 413px;
  height: 10px;
  opacity: 1;
  background: linear-gradient(180deg, #eef1f0, #e7ebea 51%, #e6ebea);
  border-radius: 5px;
  position: relative;
}
.classes-progress_value {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  border-radius: 5px;
  background: linear-gradient(180deg, #55e5b9 2%, #25c694);
}
.classes-rate_value {
  color: #22c391;
  margin-right: 16px;
}
.classes-study {
  position: absolute;
  width: 96px;
  height: 36px;
  border: 1px solid #bfbfbf;
  border-radius: 5px;
  box-sizing: border-box;
  right: 0;
  bottom: 16px;
  text-align: center;
  line-height: 34px;

  &:hover {
    border-color: $primary-color;
  }
}
.disabled {
  background-color: #ddd;
  pointer-events: none;
}
</style>
